var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "results-list" } }, [
    _c("div", { staticClass: "results-list-header" }, [
      _c("h1", { staticClass: "results-list-header-results-summary" }, [
        _vm._v(_vm._s(_vm.subheadline)),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "results-list-header-headline" }, [
        _vm._v(_vm._s(_vm.t("app-search-results"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "results-list-header-re-search" }, [
        _c(
          "button",
          { staticClass: "compact", on: { click: _vm.searchAgain } },
          [_vm._v(_vm._s(_vm.t("app-search-again")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "delivery-criteria-container" }, [
        _c("div", { staticClass: "program-delivery" }, [
          _c(
            "button",
            {
              staticClass: "compact",
              class:
                _vm.search.attributes.delivery.indexOf("community") === -1
                  ? "inactive"
                  : "",
              on: {
                click: function ($event) {
                  return _vm.onDeliveryClick("community")
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-program-delivery-community-based")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "compact",
              class:
                _vm.search.attributes.delivery.indexOf("siteBased") === -1
                  ? "inactive"
                  : "",
              on: {
                click: function ($event) {
                  return _vm.onDeliveryClick("siteBased")
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-program-delivery-site-based")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "compact",
              class:
                _vm.search.attributes.delivery.indexOf("eMentoring") === -1
                  ? "inactive"
                  : "",
              on: {
                click: function ($event) {
                  return _vm.onDeliveryClick("eMentoring")
                },
              },
            },
            [_vm._v(_vm._s(_vm.t("app-program-delivery-e-mentoring")))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "results-list-header-search-criteria" }, [
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-focus",
                attrs: {
                  name: "search-criteria-focus",
                  options: _vm.searchOptionsFocusArea,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.focus,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "focus", $$v)
                  },
                  expression: "search.attributes.focus",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria",
                  class: _vm.search.attributes.focus != "all" ? "active" : "",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick("search-criteria-list-focus")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(_vm._s(_vm.t("app-focus-area"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-age",
                attrs: {
                  name: "search-criteria-age",
                  options: _vm.searchOptionsAgesProgramServes,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.age,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "age", $$v)
                  },
                  expression: "search.attributes.age",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria",
                  class: _vm.search.attributes.age != "all" ? "active" : "",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick("search-criteria-list-age")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(_vm._s(_vm.t("app-ages"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-grade",
                attrs: {
                  name: "search-criteria-grade",
                  options: _vm.searchOptionsGrade,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.grade,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "grade", $$v)
                  },
                  expression: "search.attributes.grade",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria",
                  class: _vm.search.attributes.grade != "all" ? "active" : "",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick("search-criteria-list-grade")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(_vm._s(_vm.t("app-grades"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-youth",
                attrs: {
                  name: "search-criteria-youth",
                  options: _vm.searchOptionsYouthProgramServes,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.youth,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "youth", $$v)
                  },
                  expression: "search.attributes.youth",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria",
                  class: _vm.search.attributes.youth != "all" ? "active" : "",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick("search-criteria-list-youth")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(_vm._s(_vm.t("app-youth-served"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-type",
                attrs: {
                  name: "search-criteria-type",
                  options: _vm.searchOptionsTypeOfMentoring,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.typeOfMentoring,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "typeOfMentoring", $$v)
                  },
                  expression: "search.attributes.typeOfMentoring",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria",
                  class:
                    _vm.search.attributes.typeOfMentoring != "all"
                      ? "active"
                      : "",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick("search-criteria-list-type")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(_vm._s(_vm.t("app-mentoring-type"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-criteria-wrapper" },
            [
              _c("search-criteria-list", {
                ref: "search-criteria-list-distance",
                attrs: {
                  name: "search-criteria-distance",
                  options: _vm.searchOptionsDistance,
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update-search")
                  },
                },
                model: {
                  value: _vm.search.attributes.distance,
                  callback: function ($$v) {
                    _vm.$set(_vm.search.attributes, "distance", $$v)
                  },
                  expression: "search.attributes.distance",
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "search-criteria active",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCriteriaClick(
                        "search-criteria-list-distance"
                      )
                    },
                  },
                },
                [
                  _c("span", { staticClass: "search-criteria-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.t("app-distance-label", {
                          distance: _vm.search.attributes.distance,
                        })
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.rows.length
      ? _c(
          "div",
          [
            _c(
              "table",
              {
                staticClass: "ui-table clickable-rows",
                attrs: { id: "results-list-table" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "tbody",
                  _vm._l(_vm.rows, function (program, i) {
                    return _c(
                      "tr",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.handleClick(_vm.$props.id, program.UUID)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "result-row" }, [
                          _vm._m(0, true),
                          _vm._v(" "),
                          program.siteBased ||
                          program.communityBased ||
                          program.eMentoring
                            ? _c("div", { staticClass: "delivery" }, [
                                program.communityBased
                                  ? _c(
                                      "span",
                                      { staticClass: "delivery-tip" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.t(
                                              "app-program-delivery-community-based"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                program.siteBased
                                  ? _c(
                                      "span",
                                      { staticClass: "delivery-tip" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.t(
                                              "app-program-delivery-site-based"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                program.eMentoring
                                  ? _c(
                                      "span",
                                      { staticClass: "delivery-tip" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.t(
                                              "app-type-of-mentoring-e-mentoring"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(_vm._s(program.title)),
                          ]),
                          _vm._v(" "),
                          program.organization_title
                            ? _c("div", { staticClass: "organization-title" }, [
                                _vm._v(_vm._s(program.organization_title)),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          program.siteBased && program.googleMapUrl
                            ? _c(
                                "a",
                                {
                                  staticClass: "map-link",
                                  attrs: {
                                    target: "_blank",
                                    href: program.googleMapUrl,
                                    onclick: "event.stopPropagation()",
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "map-link-icon",
                                      attrs: {
                                        version: "1.1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "xmlns:xlink":
                                          "http://www.w3.org/1999/xlink",
                                        x: "0px",
                                        y: "0px",
                                        width: "100",
                                        height: "100",
                                        viewBox: "0 0 100 100",
                                        "enable-background": "new 0 0 100 100",
                                        "xml:space": "preserve",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "#33C2B2",
                                          d: "M78.96,79.17c-1.29-1.16-2.59-2.3-3.9-3.45c-2.63-2.28-5.31-4.53-8.04-6.75C61.56,64.53,55.88,60.22,50,56.06c-5.88,4.17-11.56,8.48-17.02,12.92c-2.73,2.22-5.41,4.47-8.04,6.75c-1.31,1.14-2.61,2.29-3.9,3.45c-5.1,4.58-10,9.29-14.68,14.09c1.59,1.63,3.44,3.01,5.5,4.06c1.96,1,4.06,1.68,6.24,2.06c2.16,0.36,4.36,0.56,6.56,0.58c1,0.02,2.02,0.04,3.02,0.04h3.58h37.45h3.58c1.02,0,2.02-0.02,3.02-0.04c2.22-0.04,4.42-0.22,6.58-0.58c2.16-0.38,4.28-1.06,6.24-2.06c2.06-1.05,3.91-2.43,5.5-4.06C88.95,88.46,84.06,83.76,78.96,79.17z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          fill: "#0D5E99",
                                          d: "M21.04,79.17c1.29-1.16,2.59-2.3,3.9-3.45c2.63-2.28,5.31-4.53,8.04-6.75c5.46-4.44,11.14-8.75,17.02-12.92C34.71,45.19,17.99,35.31,0.01,26.66C0.01,27,0,27.35,0,27.69c0,1.2,0,2.38,0,3.58v37.46c0,1.2,0,2.38,0,3.58c0,1,0.02,2.02,0.04,3.02c0.02,2.2,0.22,4.38,0.58,6.56c0.38,2.16,1.06,4.28,2.06,6.24c0.97,1.9,2.22,3.62,3.68,5.12C11.05,88.46,15.94,83.76,21.04,79.17z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          fill: "#FFAD29",
                                          d: "M67.02,68.97c2.73,2.22,5.41,4.47,8.04,6.75c1.31,1.14,2.61,2.29,3.9,3.45c5.1,4.58,10,9.29,14.68,14.09c1.47-1.5,2.71-3.22,3.68-5.12c1-1.96,1.68-4.06,2.06-6.24c0.36-2.16,0.54-4.36,0.58-6.56c0.02-1,0.04-2.02,0.04-3.02v-2.1v-41v-1.52c0-0.35-0.01-0.69-0.01-1.03C82.01,35.31,65.29,45.19,50,56.06C55.88,60.22,61.56,64.53,67.02,68.97z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          fill: "#D91C1C",
                                          d: "M99.38,18.11c-0.38-2.16-1.06-4.28-2.06-6.24C95.3,7.9,92.1,4.7,88.14,2.68c-1.96-1-4.08-1.68-6.24-2.06c-2.18-0.36-4.38-0.54-6.58-0.58C74.31,0.02,73.29,0,72.29,0h-3.58H31.27h-3.58c-1,0-2.02,0.02-3.02,0.04c-2.2,0.04-4.4,0.22-6.56,0.58C15.94,1,13.82,1.68,11.86,2.68C7.9,4.7,4.7,7.9,2.68,11.86c-1,1.96-1.68,4.06-2.06,6.24c-0.36,2.16-0.56,4.36-0.58,6.56C0.03,25.33,0.02,26,0.01,26.66C17.99,35.31,34.71,45.19,50,56.06c15.29-10.86,32.01-20.74,49.99-29.4c-0.01-0.66-0.01-1.33-0.03-1.99C99.94,22.47,99.74,20.27,99.38,18.11z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          fill: "#FFFFFF",
                                          d: "M50,14.99c-17.8,0-28.35,19.52-14.92,38.24C48.62,72.1,50,85.01,50,85.01s1.38-12.9,14.92-31.78C78.35,34.51,67.8,14.99,50,14.99z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("circle", {
                                        attrs: {
                                          fill: "#9EB8BF",
                                          cx: "50",
                                          cy: "36.44",
                                          r: "9",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "map-link-text" }, [
                                    _vm._v(
                                      _vm._s(program.physicalTip) +
                                        ", click to view in Maps"
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          program.logoUrl || program.organizationLogoUrl
                            ? _c("div", { staticClass: "logos" }, [
                                program.logoUrl
                                  ? _c(
                                      "div",
                                      { staticClass: "logo program-logo" },
                                      [
                                        _c("img", {
                                          attrs: { src: program.logoUrl },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                program.organizationLogoUrl
                                  ? _c(
                                      "div",
                                      { staticClass: "logo organization-logo" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: program.organizationLogoUrl,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          program.badges.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "float-right",
                                  attrs: { id: "nqms-badges" },
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "badges" },
                                    _vm._l(
                                      program.badges,
                                      function (badgeItem, index) {
                                        return _c(
                                          "li",
                                          { staticClass: "small" },
                                          [
                                            _c("img", {
                                              staticClass: "small",
                                              attrs: {
                                                src: badgeItem.thumbnail_url,
                                                alt: badgeItem.title,
                                                title: badgeItem.title,
                                                id: "tooltip-" + i + index,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-tooltip",
                                              {
                                                attrs: {
                                                  target:
                                                    "tooltip-" + i + index,
                                                  triggers: "hover",
                                                  placement: "auto",
                                                  customClass: "customToolTip",
                                                },
                                              },
                                              [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      badgeItem.notes
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c("pagination", {
              ref: "pagination",
              attrs: { initial: this.$props.response.data.meta.pagination },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hover-indicator" }, [
      _c("div", { staticClass: "hover-indicator-frag" }),
      _vm._v(" "),
      _c("div", { staticClass: "hover-indicator-frag" }),
      _vm._v(" "),
      _c("div", { staticClass: "hover-indicator-frag" }),
      _vm._v(" "),
      _c("div", { staticClass: "hover-indicator-frag" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }